<template>
<div>
  <div class="modal-backdrop" role="dialog" @click="persistentClose">
    <div
      class="modal "
      ref="modal"
      @click.stop
      :style="{ top: position.top, right: position.right, width: width + 'px', height: height + 'px' }"
    >
      <header class="modal-header" v-if="title">
        <slot name="header">
          <p class="cursor">
            {{ title }}
          </p>

          <img
            src="../assets/cancel.png"
            class="cross"
            width="20px"
            height="20px"
            @click="close"
          />
        </slot>
      </header>

      <section class="modal-body" :style="modalBodyStyles">
        <div v-if="!title && closeIcon" style="position:relative"> <!-- Making position relative to so that only the wrapper of cross button is positioned like not all the body (fix for dropdown bleed out).-->
          <img
            src="../assets/cancel.png"
            class="cross-absolute"
            width="20px"
            height="20px"
            @click="close"
          />
        </div>
        <slot> </slot>
      </section>

      <!-- <footer class="modal-footer" @click="close">
        <slot>
        </slot>
      </footer> -->
    </div>
</div>
</div>
</template>

<script>

export default {
name: "SDialog",

data() {
return {};
},

props: {
height: {
  type: Number,
  default: 600,
},
title: {
  type: String,
},
persistent: {
  type: Boolean,
},
width: {
  type: Number,
  default: 600,
},
closeIcon: {
  type: Boolean,
  default: true,
},
position:{
  default: function ()  {
    return {
      top: 'auto',
      bottom: 'auto',
      left: 'auto',
      right: 'auto',
    }
  }
}
},
created(){
      // Show modal and add modal-open class to body
      this.$refs.modal.style.display = "block";
      document.body.classList.add("modal-open");
},
methods: {
close(event) {
  this.$emit("close");
},
persistentClose() {
  if (!this.persistent) {
    this.$emit("close");
    this.$refs.modal.style.display = "none";
      document.body.classList.remove("modal-open");
  }
},
},
computed: {
modalBodyStyles() {
  let hei = parseInt(this.height) + "px";
  return {
    height: hei,
  };
},
modalStyles() {
  let wid = this.width + "px";
  return wid;
//     // console.log(temp)
//     return {
//       width: wid,
//       position: 'absolute',
//       top: `${this.position.top}`,
//       bottom: `${this.position.bottom}`,
//       left: `${this.position.left}`,
//       right: `${this.position.right}`,

//     };
}
}
};
</script>

<style scoped>
.top-right{
position: absolute;
top: 0;
right: 0;
}
.cross {
margin-top: 15px;
cursor: pointer;
}
.cross-absolute {
position: absolute;
right: 5px;
top: 5px;
z-index: 100;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  overflow: hidden;
}

.modal-backdrop .modal {
  max-height: 85vh;
  overflow-y: auto;
}

.modal {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 25px 0 var(--brown-grey);
  margin: 20px; /* Adjust as needed */
  overflow-y: visible;
}

/* .modalPosition {
  position: absolute;
  left: 50%;
  top:  50%;
  transform: translate(-50%,-50%);  
} */

.modal-header,
.modal-footer {
padding: 10px 30px 10px 30px;
display: flex;
}

.modal-header {
border-bottom: 1px solid var(--very-light-pink);
font-size: 16px;
font-family: "Roboto !important";
font-weight: bold;
color: black;
display: inline-flex;
justify-content: space-between;
align-items: baseline;
}

.modal-footer {
justify-content: flex-start;
padding: 26px 30px;
}

.modal-body {
position: relative;
height: auto;
}

.modal-fade-enter,
.modal-fade-leave-active {
opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
transition: opacity 0.5s ease;
}

.cursor {
cursor: default;
}
@media screen and (min-width:1440px) {
.modal {
max-height: 85vh !important;
width: 100vw;
}
}

</style>